import { render } from "./RecentForms.vue?vue&type=template&id=7b5507cd&scoped=true"
import script from "./RecentForms.vue?vue&type=script&lang=js"
export * from "./RecentForms.vue?vue&type=script&lang=js"

import "./RecentForms.vue?vue&type=style&index=0&id=7b5507cd&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7b5507cd"

export default script